module.exports = __webpack_public_path__ + "img/sun.1bbb4838.svg";